import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AuthServiceService } from 'src/app/_services/AuthService.service';
import { Pagination } from 'src/app/_models/pagination';

@Component({
  selector: 'app-emailsLogs',
  templateUrl: './emailsLogs.component.html',
  styleUrls: ['./emailsLogs.component.css']
})
export class EmailsLogsComponent implements OnInit {

  subscriptions: any;
  currentUser:any;
  emailLogs: any;
  isLoadingLogs = true;
  selectedSubscription: any;
  pagination: Pagination;

  constructor(private _adminService: AdminServiceService, private _authService: AuthServiceService) { }

  ngOnInit() {
    this.currentUser = this._authService.decodedToken;
    this.loadSubscriptionsList(this.currentUser.nameid);
  }


  private loadSubscriptionsList(userId: any) {
    this._adminService.getSubscriptionsByUserId(userId).subscribe(data => {
      this.subscriptions = data;
      this.selectedSubscription = data[0];
      if (this.pagination) this.pagination.currentPage = 1;
      this.loadEmailLog(this.selectedSubscription.apiKey);
    })
  }

  private loadEmailLog(apiKey: string) {

    this.isLoadingLogs = true;

    if (this.pagination)
    {
      this._adminService.getSubscriptionLog(apiKey, this.pagination.currentPage, this.pagination.itemsPerPage).subscribe(data => {
        this.isLoadingLogs = false;
        this.emailLogs = data.result;
        this.pagination = data.pagination;
        console.log(this.pagination);
      });
    } else {
      this._adminService.getSubscriptionLog(apiKey).subscribe(data => {
        this.isLoadingLogs = false;
        this.emailLogs = data.result;
        this.pagination = data.pagination;
        console.log(this.pagination);
      });
    }
    

  }

  pageChange(event: any): void {
    this.pagination.currentPage = event.page;
    this.loadEmailLog(this.selectedSubscription.apiKey);
  }

}
